module.exports = __webpack_public_path__ + "static/media/history_24.ed82801a.jpg";